export enum ActionTypes {
  FETCH_PROJECTS = "FETCH_PROJECTS",
  FETCH_PROJECT = "FETCH_PROJECT",
  FETCH_PACKAGE = "FETCH_PACKAGE",
  CREATE_PROJECT = "CREATE_PROJECT",
  CREATE_PACKAGE = "CREATE_PACKAGE",
  CREATE_PROJECT_TAG = "CREATE_PROJECT_TAG",
  UPDATE_PROJECT = "UPDATE_PROJECT",
}
